import createCache from '@emotion/cache';
import rtlPlugin from '@mui/stylis-plugin-rtl';
import { prefixer } from 'stylis';

export function createLtrEmotionCache() {
  return createCache({ key: 'css', prepend: true });
}

export function createRtlEmotionCache() {
  return createCache({ key: 'muirtl', prepend: true, stylisPlugins: [prefixer, rtlPlugin] });
}
